import {TprmScopeId, TprmScopeVisibility} from "platformed-client/types";
import api from "../../../api";
import {param, typedQuery} from "../../typing";

export const scope = typedQuery(["tprm", "scope", param<TprmScopeId>("scopeId")], async scopeId => {
  return await api.tprm.scopes.get(scopeId);
});

export const scopeSources = typedQuery(
  ["tprm", "scopeSources", param<TprmScopeId>("scopeId"), param<TprmScopeVisibility>("scopeVisibility")],
  async (scopeId, scopeVisibility) => {
    return await api.tprm.scopes.listSources(scopeId, scopeVisibility);
  },
);
